import { render, staticRenderFns } from "./PopupDashboardsName.vue?vue&type=template&id=a1022b2e&scoped=true"
import script from "./PopupDashboardsName.vue?vue&type=script&lang=js"
export * from "./PopupDashboardsName.vue?vue&type=script&lang=js"
import style0 from "./PopupDashboardsName.vue?vue&type=style&index=0&id=a1022b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1022b2e",
  null
  
)

export default component.exports